import { IpMapping } from 'models/ip-mapping';
import { IpMappingDTOV1 } from '../swagger-api-v1';

export class DeviceIpMappings {
  constructor(
    public deviceId: number,
    public deviceName: string,
    public ipMappings: IpMapping[]
  ) {}

  public static fromDTO(dto: IpMappingDTOV1): DeviceIpMappings {
    return new DeviceIpMappings(
      dto.deviceId,
      dto.deviceName,
      dto.ips.map((ipDto) => IpMapping.fromDTO(ipDto))
    );
  }
}
